import React, { useState } from 'react'
import Loader from '../../../loader/Loader';
import Common_Images_Transport from '../common_imges_transport/Common_Images_Transport';
import { Link, useNavigate } from 'react-router-dom';
import { IMG_BASE_URL } from '../../../config/Config';

const Mobile_Toggle = (props) => {
    const { gemstone_subcategorylist, jewellery_subcategorylist, more_Categories, categorylist, horoscopePages } = props
    const [isOpen, setIsOpen] = useState(false);
    const [is_loading, set_Is_Loading] = useState(false)
    const [isDropdownOpen, setIsDropdownOpen] = useState(0);
    const [activeAccordion, setActiveAccordion] = useState(null);

    const navigate = useNavigate()

    const gemstoneCategory = categorylist.find(item => item.id === 1);
    const jewelleryCategory = categorylist.find(item => item.id === 2);

    const Horoscope = horoscopePages?.find((item) => item?.page_name === "horoscope")
    const TodayHoroscope = horoscopePages?.find((item) => item?.page_name === "today-horoscope")
    const LoveHoroscope = horoscopePages?.find((item) => item?.page_name === "love-horoscope")
    const YesterDayHoroscope = horoscopePages?.find((item) => item?.page_name === "yesterday-horoscope")
    const TomorrowHoroscope = horoscopePages?.find((item) => item?.page_name === "tomorrow-horoscope")
    const WeeklyHoroscope = horoscopePages?.find((item) => item?.page_name === "weekly-horoscope")
    const MonthlyHoroscope = horoscopePages?.find((item) => item?.page_name === "monthly-horoscope")
    const YearlyHoroscope = horoscopePages?.find((item) => item?.page_name === "yearly-horoscope")
    const LoveCalculator = horoscopePages?.find((item) => item?.page_name === "love-calculator")

    const groupedByType = gemstone_subcategorylist.reduce((acc, item) => {
        const type = item?.type;
        if (!type?.id || !type?.name || type?.name === "null" || type?.name === "undefined") {
            return acc; // skip invalid
        }
        if (!acc[type.id]) {
            acc[type.id] = { name: type.name, items: [] };
        }
        acc[type.id].items.push(item);
        return acc;
    }, {});

    const groupedByTypeJewellery = jewellery_subcategorylist.reduce((acc, item) => {
        const type = item?.type;
        if (!type?.id || !type?.name || type?.name === "null" || type?.name === "undefined") {
            return acc; // Skip invalid types
        }
        if (!acc[type.id]) {
            acc[type.id] = { name: type.name, items: [] };
        }
        acc[type.id].items.push(item);
        return acc;
    }, {});

    const toggleOffcanvas = () => {
        setIsOpen(!isOpen);
    };
    const handleDropdown = (tab) => {
        if (isDropdownOpen == tab) {
            setIsDropdownOpen(0)
            return
        } else {
            setIsDropdownOpen(tab)

        }
    }

    const toggleAccordion = (menu) => {
        setActiveAccordion(menu === activeAccordion ? null : menu);
    };

    return (
        <div>
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>

                        <Link to="javascript:void(0)"
                            onClick={toggleOffcanvas}
                            className="gi-header-btn gi-site-menu-icon absolute relative transition-all duration-[0.3s] ease-in-out relative flex text-[#fff] w-[auto] items-center">
                            <i className="fi-rr-menu-burger text-[24px] leading-[17px]"></i>
                        </Link>
                        <div
                            className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity
                                 ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
                            onClick={toggleOffcanvas}></div>
                        <div
                            className={`fixed top-0 left-0 w-[320px] h-full bg-white shadow-lg z-50 p-0
    transform transition-transform duration-300 ease-in-out 
    ${isOpen ? "translate-x-0" : "-translate-x-full"}`} // changed translate-x-full to -translate-x-full for left-side closing
                        >
                            <div className="flex flex-col h-full ">
                                <div className="flex justify-between p-4 items-center">
                                    <span className="menu_title flex items-center"> <img
                                        src={Common_Images_Transport?.logo} width={110} alt="" /> </span>
                                    <button
                                        onClick={toggleOffcanvas}
                                        className="text-gray-600 hover:text-gray-900"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-6 w-6"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M6 18L18 6M6 6l12 12"
                                            />
                                        </svg>
                                    </button>
                                </div>
                                <div className="gi-menu-inner overflow-y-scroll">
                                    <div className="gi-menu-content">
                                        <ul className="space-y-4 px-4">
                                            <li className="dropdown relative ">
                                                <div className='flex justify-between items-center text-gray-800 gap-2'>
                                                    <Link to={`/${gemstoneCategory?.slug}`} onClick={toggleOffcanvas}
                                                        className="text-[13px] text-gray-800 font-semibold"><span>
                                                            Gemstones</span> </Link>
                                                    <button className="flex items-center justify-center w-5 h-5 bg-gray-200 font-semibold rounded-full text-lg flex-shrink-0" onClick={() => handleDropdown(1)}>{isDropdownOpen == 1 ? "-" : "+"}</button>

                                                </div>
                                                <ul
                                                    className={`sub-menu w-full min-w-[auto] p-3 space-y-2 bg-white static  visible transition-none opacity-[1] ${isDropdownOpen != 1 && "hidden"}`}>
                                                    <li>
                                                        {gemstone_subcategorylist?.length > 0 && (
                                                            <div className="menu_all_gemstone bg-white">

                                                                <ul className="sub-menu lg:grid grid-cols-5 ">

                                                                    {Object.entries(groupedByType).map(([typeId, group]) => (
                                                                        <li key={typeId} className="all_menus">

                                                                            <div className="title_heading text-[13px] text-dark font-medium">
                                                                                <span
                                                                                    onClick={() => {
                                                                                        navigate(`/${gemstoneCategory?.slug}`, {
                                                                                            state: { typeId: Number(typeId) },
                                                                                        });
                                                                                        // setIsDropdownOpen(false);
                                                                                    }}
                                                                                >{group.name}</span>
                                                                                <span className='float-right min-[991px]:hidden block p-1' onClick={() => toggleAccordion(typeId)}> <svg data-accordion-icon className={`size-3 shrink-0 ${activeAccordion == typeId ? 'rotate-0' : 'rotate-180'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                                                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
                                                                                </svg></span>
                                                                            </div>

                                                                            <ul className={`${activeAccordion == typeId ? "block" : "hidden"}`}>
                                                                                {group?.items?.map((sub_category_result, ind) => (
                                                                                    <li key={ind} className='cursor-pointer'>
                                                                                        <Link to={`/${gemstoneCategory?.slug}/${sub_category_result?.slug}`}>
                                                                                            <span>
                                                                                                <img alt={sub_category_result?.image_alt
                                                                                                } src={`${IMG_BASE_URL}${sub_category_result?.image}`} /></span>
                                                                                            {sub_category_result?.title}
                                                                                        </Link>

                                                                                    </li>
                                                                                ))}

                                                                            </ul>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </li>

                                                </ul>
                                            </li>
                                            <li className="dropdown relative">
                                                <div className='flex justify-between items-center text-gray-800 gap-2'>
                                                    <Link to={`/${jewelleryCategory?.slug}` } onClick={toggleOffcanvas}
                                                        className="text-[13px] text-gray-800 font-semibold "><span>
                                                            Jewellery</span> </Link>
                                                    <button className="flex items-center justify-center w-5 h-5 bg-gray-200 font-semibold rounded-full text-lg flex-shrink-0" onClick={() => handleDropdown(2)}>{isDropdownOpen == 2 ? "-" : "+"}</button>
                                                </div>
                                                <ul
                                                    className={`sub-menu w-full min-w-[auto] p-3 space-y-2 bg-white static  visible transition-none opacity-[1] ${isDropdownOpen != 2 && "hidden"}`}>
                                                    <li>
                                                        {jewellery_subcategorylist?.length > 0 && (
                                                            <div className="menu_all_gemstone bg-white">


                                                                <ul className="sub-menu lg:grid grid-cols-5 ">
                                                                    {Object.entries(groupedByTypeJewellery).map(([typeId, group]) => (
                                                                        <li key={typeId} className="all_menus">

                                                                            <div className="title_heading text-[13px] text-dark font-medium">
                                                                                <span onClick={() => {
                                                                                    navigate(`/${jewelleryCategory?.slug}`, { state: { typeId: Number(typeId) } })
                                                                                    // setIsDropdownOpen(false);
                                                                                }
                                                                                }>{group.name}</span>
                                                                                <span className='float-right min-[991px]:hidden block p-1' onClick={() => toggleAccordion(typeId)}> <svg data-accordion-icon className={`size-3 shrink-0 ${activeAccordion == typeId ? 'rotate-0' : 'rotate-180'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                                                                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5" />
                                                                                </svg></span>
                                                                            </div>

                                                                            <ul className={`${activeAccordion == typeId ? "block" : "hidden"}`}>
                                                                                {group?.items?.map((sub_category_result, ind) => (
                                                                                    <li key={ind} className='cursor-pointer'>
                                                                                        <Link to={`/${jewelleryCategory?.slug}/${sub_category_result?.slug}`}>
                                                                                            <span>
                                                                                                <img alt={sub_category_result?.image_alt
                                                                                                } src={`${IMG_BASE_URL}${sub_category_result?.image}`} /></span>
                                                                                            {sub_category_result?.title}
                                                                                        </Link>

                                                                                    </li>
                                                                                ))}

                                                                            </ul>
                                                                        </li>
                                                                    ))}

                                                                </ul>
                                                            </div>
                                                        )}
                                                    </li>

                                                </ul>
                                            </li>

                                            <li className="dropdown relative">
                                                <div className='flex justify-between items-center text-gray-800 gap-2'>
                                                    <Link to="#" onClick={() => handleDropdown(3)}
                                                        className="text-[13px] text-gray-800 font-semibold "><span>
                                                            More</span></Link>
                                                    <button className="flex items-center justify-center w-5 h-5 bg-gray-200 font-semibold rounded-full text-lg flex-shrink-0" onClick={() => handleDropdown(3)}>{isDropdownOpen == 3 ? "-" : "+"}</button>
                                                </div>
                                                <ul
                                                    className={`sub-menu w-full min-w-[auto] p-3 space-y-2 bg-white static  visible transition-none opacity-[1] ${isDropdownOpen != 3 && "hidden"}`}>
                                                    {more_Categories?.map((more_type) => (
                                                        <li><Link to={`/${more_type?.slug}`}
                                                            className=" leading-[20px] px-[20px] py-[6px] font-medium text-[11px] text-gray-700 uppercase flex justify-start gap-3 items-center hover:text-[#9F2225]">
                                                            <span >
                                                                <img alt={more_type?.image_alt
                                                                } src={`${IMG_BASE_URL}${more_type?.image}`} className='max-w-6' /></span>
                                                            {more_type?.title}
                                                        </Link></li>
                                                    ))}

                                                </ul>
                                            </li>

                                            <li className="dropdown relative drop-list">
                                                <Link to="/recommend-gemstone" onClick={toggleOffcanvas}
                                                    className="text-[13px] text-gray-800 font-semibold">Gem Recommendation</Link>

                                            </li>
                                            <li className="dropdown relative drop-list">
                                                <Link to="/custom-jewelry" onClick={toggleOffcanvas}
                                                    className="text-[13px] text-gray-800 font-semibold">custom jewellery</Link>

                                            </li>

                                            <li className="dropdown relative">
                                                <div className='flex justify-between items-center text-gray-800 gap-2'>
                                                    <Link to={undefined}
                                                        // onClick={(e) => e.preventDefault()}
                                                        onClick={() => handleDropdown(4)}
                                                        className="text-[13px] text-gray-800 font-semibold "><span>Daily
                                                            Horoscope</span></Link>
                                                    <button className="flex items-center justify-center w-5 h-5 bg-gray-200 font-semibold rounded-full text-lg flex-shrink-0" onClick={() => handleDropdown(4)}>{isDropdownOpen == 4 ? "-" : "+"}</button>
                                                </div>
                                                <ul
                                                    className={`sub-menu w-full min-w-[auto] px-5 py-2 space-y-2 static  visible transition-none opacity-[1] ${isDropdownOpen != 4 && "hidden"}`}>
                                                    <li className=''><Link to={`/horoscope/${Horoscope?.slug}`}
                                                        className="text-[12px] text-gray-800 font-semibold">Horoscope</Link></li>
                                                    <li><Link to={`/horoscope/${TodayHoroscope?.slug}`}
                                                        className="text-[12px] text-gray-800 font-semibold">Today Horoscope</Link></li>
                                                    <li><Link to={`/horoscope/${LoveHoroscope?.slug}`}
                                                        className="text-[12px] text-gray-800 font-semibold">Love Horoscope</Link></li>
                                                    <li><Link to={`/horoscope/${YesterDayHoroscope?.slug}`}
                                                        className="text-[12px] text-gray-800 font-semibold">Yesterday Horoscope</Link></li>
                                                    <li><Link to={`/horoscope/${TomorrowHoroscope?.slug}`}
                                                        className="text-[12px] text-gray-800 font-semibold">Tomorrow's Horoscope</Link></li>
                                                    <li><Link to={`/horoscope/${WeeklyHoroscope?.slug}`}
                                                        className="text-[12px] text-gray-800 font-semibold">Weekly Horoscope</Link></li>
                                                    <li><Link to={`/horoscope/${MonthlyHoroscope?.slug}`}
                                                        className="text-[12px] text-gray-800 font-semibold">Monthly Horoscope</Link></li>
                                                    <li><Link to={`/horoscope/${YearlyHoroscope?.slug}`}
                                                        className="text-[12px] text-gray-800 font-semibold">Yearly Horoscope</Link></li>
                                                    {/* <li><Link to="#"
                                                        className="text-[12px] text-gray-800 font-semibold">Chinese
                                                        Horoscope</Link></li> */}
                                                </ul>
                                            </li>


                                            <li className="relative">
                                                <Link to={`/page/${LoveCalculator?.slug}`}
                                                    className="text-[13px] text-gray-800 font-semibold">Love Calculator</Link>

                                            </li>
                                            <li className="relative">
                                                <Link to="/pooja"
                                                    className="text-[13px] text-gray-800 font-semibold">Book Pooja</Link>

                                            </li>

                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </>
                )
            }
        </div >
    )
}

export default Mobile_Toggle